import {
  Badge,
  HStack,
  ListItem,
  Text,
  UnorderedList,
  VStack,
  Box,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { EventDetailScheduledUpdatesSection } from "@common/interfaces/KYDEvent";
import {
  getChangedFields,
  ScheduledUpdateValues,
} from "../EditScheduledUpdateModal";
import dayjs from "dayjs";
import { formatFullDate } from "../ScheduledUpdatesTable";

export const labelToText = (label: string) => {
  if (label === "Name") {
    return "Event name Update";
  }
  if (label === "Description") {
    return "Description Update";
  }
  if (label === "Date") {
    return "Event date Update";
  }

  if (label === "Poster") {
    return "Poster Update";
  }

  if (label === "Performers") {
    return "Lineup Update";
  }

  if (label === "Performers") {
    return "Performers Update";
  }

  return label;
};

export const ReviewItem = ({ label, value }: { label: string; value: any }) => {
  console.log({ label, value });
  return (
    <ListItem
      w="full"
      borderBottomWidth={1}
      borderColor={"gray.200"}
      listStyleType="none"
      display="flex"
      alignItems="center"
      py={3}
      px={4}
    >
      <Box
        as="span"
        display="inline-block"
        w="8px"
        h="8px"
        bg="gray.400"
        borderRadius="full"
        mr={3}
      />
      <HStack w="full" justify={"space-between"}>
        <Text fontWeight={"medium"}>{labelToText(label)}</Text>
        <Badge
          colorScheme={value ? "blue" : "gray"}
          rounded={"full"}
          px={2}
          fontSize={"sm"}
          fontWeight={"medium"}
          textTransform={"initial"}
        >
          {value ? "Scheduled" : "Skipped"}
        </Badge>
      </HStack>
    </ListItem>
  );
};

const ReviewStep = ({
  data,
  isLoading = false,
}: {
  data: Pick<
    EventDetailScheduledUpdatesSection["data"],
    | "timezone"
    | "name"
    | "description"
    | "description_rich"
    | "poster"
    | "performers"
  >;
  isLoading?: boolean;
}) => {
  const {
    formState: { dirtyFields, defaultValues, errors, isValid },
    getValues,
    watch,
  } = useFormContext<ScheduledUpdateValues>();

  const changedFields = getChangedFields(getValues(), {
    id: undefined,
    name: data.name,
    description: data.description,
    description_rich: data.description_rich,
    date: null,
    poster: data.poster,
    new_performers: data.performers,
  });
  return (
    <VStack w={"full"} py={4}>
      <UnorderedList w="full" spacing={0} margin={0}>
        <Text
          fontWeight={"medium"}
          textTransform={"uppercase"}
          color="gray.500"
        >
          {formatFullDate(dayjs(changedFields.date), data.timezone)}
        </Text>
        <ReviewItem
          label="Performers"
          value={
            changedFields.new_performers?.length > 0
              ? changedFields.new_performers.length.toString()
              : null
          }
        />
        <ReviewItem label="Name" value={changedFields.name} />
        <ReviewItem
          label="Description"
          value={changedFields.description || changedFields.description_rich}
        />
        <ReviewItem label="Poster" value={changedFields.poster} />
      </UnorderedList>
      <Text color="red.500" fontSize={"sm"}>
        {errors.date?.message}
      </Text>
    </VStack>
  );
};

export default ReviewStep;
